<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>工讀生管理</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>工讀生管理</span></li>
          <li><span>工讀生清單</span></li>
          <li><span>工作記錄表</span></li>
        </ol>
      </div>
    </header>
    <div id="calendar" class="row">
      <div class="col-md-12">
        <section class="panel">
          <header class="panel-heading">
            <div class="panel-actions">
              <a href="#" class="panel-action panel-action-toggle" data-panel-toggle=""></a>
            </div>
            <h2 class="panel-title">排班</h2>
          </header>
          <div class="panel-body">
            <div class="row">
              <div class="col-md-12">
                <a href="#" v-if="isBursary&&checkServiceFeedback!='未排班'" :disabled="checkServiceFeedback!=''" 
                :title="checkServiceFeedback=='時間未到'?'月底開放填寫心得':checkServiceFeedback=='時間已過'?'已超過填寫心得時間':checkServiceFeedback=='已審核'?'已審核不可修改':''" 
                @click.prevent="toServiceFeedbackPage" class="btn btn-upload" 
                style="background-color: red; border-color: red; color: #fff; font-weight: bold; z-index: 999;">當月服務心得</a>
              </div>
            </div>
            
            <div :id="this.uid" class="monthly" ref="monthly"></div>
          </div>
        </section>
      </div>
    </div>
    <div id="single" class="calendar-popup dialog dialog-sm zoom-anim-dialog mfp-hide">
      <h3 tkey="singleTitle"></h3>
      <div class="popup-content">
        <div class="text-center" tkey="unit-text"></div>
        <div class="btn-block text-center">
          <a href="" class="btn btn-default" tkey="singleLeave">請假</a>
          <a href="" class="btn btn-primary" tkey="singleRecord">工作紀錄表</a>;
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      isBursary: false,
      year: 0,
      month: 0,
      checkServiceFeedback: ""
    };
  },
  mounted() {
    this.calendar();
    $(".popup-with-zoom-anim").magnificPopup({
      type: "inline",
      fixedContentPos: false,
      fixedBgPos: true,
      overflowY: "auto",
      closeBtnInside: true,
      preloader: false,
      midClick: true,
      removalDelay: 300,
      mainClass: "my-mfp-zoom-in"
    });
    this.year = $(this.$refs.monthly).data("setYear");
    this.month = $(this.$refs.monthly).data("setMonth");
    this.$http.get("/api/workstudyStudent/isBursary").then(a => {
      this.isBursary = a.body;
      this.doCheckServiceFeedback();
    });
  },
  methods: {
    calendar() {
      let vm = this;
      let monthly = this.$refs.monthly;
      $(monthly).monthly({
        mode: "event",
        jsonUrl: "/api/workstudyStudent/schedule-json",
        dataType: "json",
        weekStart: 0,
        dayNames: ["日", "一", "二", "三", "四", "五", "六"]
      });
      $(monthly).on("monthChange", function(_, a) {
        vm.year = a.year;
        vm.month = a.month;
      });
      $(monthly).on("click touchstart", ".btn-popup", function(e) {
        e.preventDefault();
        if ($(this).attr("href") == "#multiple") {
          setTimeout(() => {
            vm.loadDelList();
          }, 100);
          $.magnificPopup.open({
            items: { src: $(this).attr("href") },
            type: "inline",
            fixedContentPos: false,
            fixedBgPos: true,
            overflowY: "auto",
            closeBtnInside: true,
            preloader: false,
            midClick: true,
            removalDelay: 300,
            mainClass: "my-mfp-zoom-in"
          }, 0);
        } else {
          if ($(window).width() <= 768) {
            console.log($(this));
            var urlName = $(this).text();
            var urlLeave = $(this).next().next().find("[tkey='calendarLeave']").attr("href");
            var urlRecord = $(this).next().next().find("[tkey='calendarRecord']").attr("href");
            var unitText = $(this).next().text();
            $.magnificPopup.open({
              items: { src: $(this).attr("href") },
              type: "inline",
              fixedContentPos: false,
              fixedBgPos: true,
              overflowY: "auto",
              closeBtnInside: true,
              preloader: false,
              midClick: true,
              removalDelay: 300,
              mainClass: "my-mfp-zoom-in"
            }, 0);
            $("#single [tkey='singleLeave']").attr("href", urlLeave);
            $("#single [tkey='singleRecord']").attr("href", urlRecord);
            if(!urlLeave){
              $("#single [tkey='singleLeave']").attr("disabled", "disabled");
              $("#single [tkey='singleLeave']").attr("href", "javascript:;");
            }
            if(!urlRecord){
              $("#single [tkey='singleRecord']").attr("disabled", "disabled");
              $("#single [tkey='singleRecord']").attr("href", "javascript:;");
            }
            $("#single [tkey='singleTitle']").text(urlName);
            $("#single [tkey='unit-text']").text(unitText);
          }
        }
        $(".calendar-popup").on("click", ".btnPopupClose", function() {
          $.magnificPopup.close();
        });
      });
    },
    popupClose() {
      $.magnificPopup.close();
    },
    toServiceFeedbackPage() {
      if (this.checkServiceFeedback!='') return false;
      let year = $(this.$refs.monthly).data("setYear");
      let month = $(this.$refs.monthly).data("setMonth");
      this.$router.push("/student/service-feedback/" + year + "/" + month);
    },
    doCheckServiceFeedback() {
      if (this.isBursary) {
        this.$http.get("/api/workstudyStudent/checkServiceFeedback", {
          params: {
            year: this.year,
            month: this.month
          }
        }).then(a => {
          this.checkServiceFeedback = a.body;
        });
      }
    }
  },
  watch: {
    month() {
      this.doCheckServiceFeedback();
    }
  }
};
</script>

<style>
.pointer-events {
  pointer-events: auto !important;
}
</style>